import pluralize from "pluralize";
import React from "react";

import { formatCurrency } from "@/utils/helpers";

import { useEnquiryInfoContext } from "./EnquiryInfoContext";
import styles from "./styles.module.css";

interface Props {
  children: React.ReactNode;
}

const Layout = ({ children }: Props) => {
  const { title, price, nights } = useEnquiryInfoContext();

  return (
    <>
      <header className={styles.modalHeader}>
        <div data-component="title">
          <div data-component="name">
            <h2 id="modal-title">{title}</h2>

            {nights && <h4>{pluralize("nights", Number(nights), true)}</h4>}
          </div>

          {price && (
            <div className={styles.price}>
              <span data-content="from">from</span>
              <span data-content="price">{formatCurrency(Number(price))}</span>
              <div>per person</div>
            </div>
          )}
        </div>

        <p>Book With Confidence - Best Price Guarantee</p>
      </header>
      <div className="overflow-y-auto p-7">{children}</div>
    </>
  );
};

export default Layout;
